<template>
	<div 
		class="pxrwwfgv-dragging-iv"
		:class="{'-transition': backAnim}"
		v-if="display"
		:style="{
			'background-image': 'url(' + dragIntervention.thumbnail + ')',
			left: dragCoords[0]+'px',
			top: dragCoords[1]+'px',
		}"
	></div>
</template>

<script setup >
	import {ref, computed, watch} from 'vue';
	import {useStore} from 'vuex';
	import _ from 'lodash';

	const store = useStore();

	const display = ref(store.getters['inDrag']);
	const backAnim = ref(false);
	let animTo = null;
	const dragIntervention = ref(store.getters['dragIntervention']);

	const dragCoords = ref([0, 0]);
	const storeCoords = computed(() => store.getters['dragCoords']);

	const inDrag = computed(() => store.getters['inDrag']);

	function playBackAnim(){
		dragCoords.value = [200, 300];
		animTo = setTimeout(() => {
			display.value = false;
			backAnim.value = false;
			dragIntervention.value = null;
		}, 1000);
	}

	function resetBackAnim(){
		clearTimeout(animTo);
		animTo = null;
		backAnim.value = false;
	}

	watch(inDrag, (newInDrag, oldInDrag) => { 
		if(newInDrag){
			display.value = true;
			dragIntervention.value = store.getters['dragIntervention'];

			resetBackAnim();
		}
		else {
			backAnim.value = (oldInDrag && !store.getters['acceptingDropSpot']);

			if(backAnim.value){
				playBackAnim();
			}
			else {
				display.value = false;
				dragIntervention.value = null;
			}
		}
	});

	watch(storeCoords, () => { 
		if(inDrag.value){
			dragCoords.value = storeCoords.value;
		}
	});

	//undo
	const placedInterventions = computed(() => {
		return store.getters.placedInterventions;
	});

	watch(placedInterventions, (newPlacedInterventions, oldPlacedInterventions) => {
		const removedItems = _.filter(oldPlacedInterventions, (oI) => {
			return !_.some(newPlacedInterventions, (nI) => oI.dropSpot.id === nI.dropSpot.id);
		});

		if(!_.isEmpty(removedItems)){
			_.forEach(removedItems, function(p) {
				resetBackAnim();
				dragCoords.value = p.dropSpot.coords;
				dragIntervention.value = p.intervention;
				display.value = true;

				setTimeout(() =>{
					backAnim.value = true;
					playBackAnim();
				},0);

				return false;
			});
		}
	});
</script>

<style scoped>
	.pxrwwfgv-dragging-iv {
		position: absolute;
		z-index: 5;
		display: flex;
		justify-content: center;
		align-items: center;
		width: 122px;
		height: 122px;
		border-radius: 100%;
		cursor: move;
		background-size: contain;
		background-position: 50% 50%;
		background-repeat: no-repeat;
		transform: translateX(-50%) translateY(-50%);
	}

	.pxrwwfgv-dragging-iv.-transition {
		opacity: 0;
		transition: all 1000ms cubic-bezier(0.0, 0.5, 0.5, 1);
	}
</style>